import { useRedirectUrl } from "@/shared/hooks/useRedirectUrl";
import { QUERY_PARAMS } from "@motain/web-shared-hub/constants";

export const useRedirectUrlOnSuccess = (): string => {
  const redirectUrl = useRedirectUrl();
  try {
    const urlTest = new URL(redirectUrl);
    const params = new URLSearchParams(urlTest.search);
    params.append(QUERY_PARAMS.successPurchase, "true");
    urlTest.search = params.toString();
    return urlTest.href;
  } catch {
    return redirectUrl;
  }
};
